'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _iconCheckbox = require('../icons/icon-checkbox');

var _iconCheckbox2 = _interopRequireDefault(_iconCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  /** The input's label text */
  label: _propTypes2.default.node.isRequired,
  /** The input's name */
  name: _propTypes2.default.node.isRequired,
  /**
   * Callback fired when the input's value is changed
   *
   * function(event: object) => void
   */
  onChange: _propTypes2.default.func.isRequired,
  /** Checkbox checked */
  checked: _propTypes2.default.bool,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the input element */
  inputStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the icon element */
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the label element */
  labelStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the unchecked element */
  uncheckedStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The checkbox' value */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  inputStyle: {},
  iconStyle: {},
  labelStyle: {},
  uncheckedStyle: {},
  checked: false
};

var displayName = 'Checkbox';

/** A checkbox is used to verify which options you want selected from a group. */
var Checkbox = function Checkbox(_ref) {
  var onChange = _ref.onChange,
      label = _ref.label,
      checked = _ref.checked,
      name = _ref.name,
      style = _ref.style,
      inputStyle = _ref.inputStyle,
      iconStyle = _ref.iconStyle,
      labelStyle = _ref.labelStyle,
      uncheckedStyle = _ref.uncheckedStyle,
      value = _ref.value,
      color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['onChange', 'label', 'checked', 'name', 'style', 'inputStyle', 'iconStyle', 'labelStyle', 'uncheckedStyle', 'value', 'color']);

  return _react2.default.createElement(
    'label',
    _extends({ htmlFor: name, style: _getStyles2.default.root(color, style) }, custom),
    _react2.default.createElement('input', {
      type: 'checkbox',
      id: name,
      onChange: onChange,
      checked: checked,
      style: _getStyles2.default.input(inputStyle),
      value: value
    }),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.icon(iconStyle) },
      checked ? _react2.default.createElement(_iconCheckbox2.default, { color: color }) : _react2.default.createElement('div', { style: _getStyles2.default.unchecked(uncheckedStyle) })
    ),
    _react2.default.createElement(
      'span',
      { style: _getStyles2.default.label(labelStyle) },
      label
    )
  );
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = displayName;

exports.default = Checkbox;
module.exports = exports.default;